import { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { LinkIcon, LinkLabel, LinkText } from './styled'
import { SvgIconProps } from '@mui/material'
import { MAIN_COLOR_CC, MAIN_COLOR_QRM } from 'shared/globalConsts'
import { selectedApp } from 'app'

export const SideBarIcon: FC<IMenuProps> = ({ routeName, icon: Icon, label }) => {
  const location = useLocation()

  const getColor = () => {
    if (location.pathname === routeName) {
      // TODO: replace with real detector
      if (selectedApp === 'qrmenu') {
        return MAIN_COLOR_QRM
      } else {
        return MAIN_COLOR_CC
      }
    } else {
      return 'unset'
    }
  }

  return (
    <Link to={routeName || '/'}>
      <LinkIcon>{Icon ? <Icon sx={{ color: getColor() }} /> : label?.charAt(0)}</LinkIcon>
      <LinkLabel title={label || ''} color={getColor()}>
        <LinkText color=''>{label}</LinkText>
      </LinkLabel>
    </Link>
  )
}

export interface IMenuProps {
  icon?: (props: SvgIconProps) => any
  label?: string | null
  routeName?: string
}
